export const cleanURL = (url) =>
  url
    .replace("https://", "")
    .replace("http://", "")
    .replace(/(?:\/+(\?))/, "$1")
    .replace(/\/+$/, "");
